import "rc-slider/assets/index.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";

import { AppDispatch, RootState } from "../../core/data/redux/store";
import { setSidebarFilters } from "../../core/data/redux/action";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import TooltipSlider from "./TooltipSlider";

const MobileFilterSidebar: React.FC<{
  applyFilters?: (any: any) => void;
  setSearchText?: React.Dispatch<React.SetStateAction<string>>;
  searchText?: string;
}> = ({ applyFilters, searchText, setSearchText }) => {
  const dispatch = useDispatch<AppDispatch>();

  const { filterData, selectedFilters } = useSelector(
    (state: RootState) => state.sidebarFilter
  );

  const [filters, setFilters] = useState(selectedFilters);

  // const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value, type, checked } = e.target;

  //   setFilters((prev: any) => ({
  //     ...prev,
  //     [name]:
  //       type === "radio"
  //         ? value
  //         : checked
  //           ? [...(prev[name] || []), value]
  //           : (prev[name] || []).filter((v: any) => v !== value),
  //   }));
  // };

  
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value, type, checked } = e.target;

  setFilters((prev: any) => {
    if (type === "radio") {
      return {
        ...prev,
        [name]: value,
      };
    }

    const prevValues = Array.isArray(prev[name]) ? prev[name] : [];

    return {
      ...prev,
      [name]: checked
        ? [...prevValues, value]
        : prevValues.filter((v: any) => v !== value),
    };
  });
};


  const min = Number(filterData?.price_range?.min_price) || 0;
  const max = Number(filterData?.price_range?.max_price) || 100;
  const [priceRange, setPriceRange] = useState<number[]>(
    filters.price || [min, max]
  );

  const handlePriceChange = (value: number | number[]) => {
    if (Array.isArray(value)) {
      setPriceRange(value);
      setFilters((prev: any) => ({
        ...prev,
        price: value,
      }));
    }
  };

  const handleSubmit = () => {
    if (JSON.stringify(filters) !== JSON.stringify(selectedFilters)) {
      dispatch(setSidebarFilters(filters));
      applyFilters?.(filters);
    } else {
      dispatch(setSidebarFilters(selectedFilters));
      applyFilters?.(selectedFilters);
    }
  };

  const handleSearchClick = () => {
    if (searchText !== selectedFilters?.searchText) {
      const newFilters = { ...filters, searchText };
      setFilters(newFilters);
      dispatch(setSidebarFilters(newFilters));
      applyFilters?.(newFilters);
    }
  };

  const handleReset = () => {
    setFilters({});
    setSearchText?.("");
    dispatch(setSidebarFilters({}));
    applyFilters?.([]);
  };

  return (
    <>
      <div className="col-xl-3 col-lg-4 col-sm-12 col-12 theiaStickySidebar">
        <div className="stickybar d-none d-md-flex">
          <FormValidation
            handleSubmit={handleSubmit}
            handleReset={handleReset}
            searchText={searchText}
            setSearchText={setSearchText}
            handleSearchClick={handleSearchClick}
            filterData={filterData}
            priceRange={priceRange}
            handlePriceChange={handlePriceChange}
            min={min}
            max={max}
            filters={filters}
            handleFilterChange={handleFilterChange}
          />
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={33}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              document.body.style.overflow = "";
              document.body.style.paddingRight = "";
            }}
          ></button>
        </div>
        <div className="offcanvas-body">
          <FormValidation
            handleSubmit={handleSubmit}
            handleReset={handleReset}
            searchText={searchText}
            setSearchText={setSearchText}
            handleSearchClick={handleSearchClick}
            filterData={filterData}
            priceRange={priceRange}
            handlePriceChange={handlePriceChange}
            min={min}
            max={max}
            filters={filters}
            handleFilterChange={handleFilterChange}
          />
        </div>
      </div>
    </>
  );
};

const FormValidation = (props: any) => {
  return (
    <form
      onSubmit={props.handleSubmit}
      action="#"
      autoComplete="off"
      className=""
    >
      <div className="d-flex align-items-center gap-2 pb-3">
        <button
          type="submit"
          className="d-inline-flex align-items-center justify-content-center btn btn-primary text-nowrap w-100"
        >
          <span>
            <i className="feather icon-filter fs-12 me-2" />
          </span>
          Apply Filter
        </button>

        <button
          onClick={props.handleReset}
          type="button"
          className="d-inline-flex align-items-center justify-content-center  btn btn-order w-100"
        >
          Reset Filter
        </button>
      </div>

      <div className="sidebar-heading">
        <h6 className="fs-14">What Are You Looking For</h6>
      </div>

      <div className="product-search">
        <div className="form-custom">
          <input
            type="text"
            name="searchText"
            className="form-control"
            defaultValue={props.searchText || ""}
            onChange={(e) => props.setSearchText?.(e.target.value)}
            id="member_search1"
          />
          <span>
            <div
              onClick={props.handleSearchClick}
              style={{ cursor: "pointer" }}
            >
              <ImageWithBasePath src="assets/img/icons/search.svg" alt="img" />
            </div>
          </span>
        </div>
      </div>
      <div className="accord-list">
        <div className="accordion" id="accordionMain1">
          <div className="card-header-new" id="headingOne">
            <h6 className="filter-title">
              <Link
                to="#"
                className="w-100 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Price Per Day ${props.priceRange[0]} - ${props.priceRange[1]}
                <span className="float-end">
                  <i className="fa-solid fa-chevron-down" />
                </span>
              </Link>
            </h6>
          </div>
          <div
            id="collapseOne"
            className="collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionMain1"
          >
            <div className="card-body-chat">
              <div className="px-2 filter-range">
                <TooltipSlider
                  range
                  min={props.min}
                  max={props.max}
                  onChange={props?.handlePriceChange}
                  marks={{
                    [props.min]: `$${props.min}`,
                    [props.max]: `$${props.max}`,
                  }}
                  value={props.priceRange || [props.min, props.max]}
                  tipFormatter={(value: any) => `$${value}`}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="accordion" id="accordionMain4">
          <div className="card-header-new" id="headingFour">
            <h6 className="filter-title">
              <Link
                to="#"
                className="w-100 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                Make
                <span className="float-end">
                  <i className="fa-solid fa-chevron-down" />
                </span>
              </Link>
            </h6>
          </div>
          <div
            id="collapseFour"
            className="collapse  "
            aria-labelledby="headingFour"
            data-bs-parent="#accordionMain4"
          >
            <div className="card-body-chat">
              <div className="row">
                <div className="col-md-12">
                  <div id="checkBoxes1">
                    <div className="selectBox-cont">
                      {props.filterData?.car_brand?.map((brand: string) => (
                        <label key={brand} className="custom_check w-100">
                          <input
                            type="checkbox"
                            name="make"
                            value={brand}
                            checked={
                              props.filters.make?.includes(brand) || false
                            }
                            onChange={props.handleFilterChange}
                          />
                          <span className="checkmark" /> {brand}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion" id="accordionMain5">
          <div className="card-header-new" id="headingYear">
            <h6 className="filter-title">
              <Link
                to="#"
                className="w-100 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#collapseYear"
                aria-expanded="true"
                aria-controls="collapseYear"
              >
                Year
                <span className="float-end">
                  <i className="fa-solid fa-chevron-down" />
                </span>
              </Link>
            </h6>
          </div>
          <div
            id="collapseYear"
            className="collapse"
            aria-labelledby="headingYear"
            data-bs-parent="#accordionMain5"
          >
            <div className="card-body-chat">
              <div id="checkBoxes02">
                <div className="selectBox-cont">
                  {props.filterData?.car_year?.map((year: string) => (
                    <label key={year} className="custom_check w-100">
                      <input
                        type="checkbox"
                        name="year"
                        checked={props.filters.year?.includes(year) || false}
                        value={year}
                        onChange={props.handleFilterChange}
                      />
                      <span className="checkmark" /> {year}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion" id="accordionMain2">
          <div className="card-header-new" id="headingTwo">
            <h6 className="filter-title">
              <Link
                to="#"
                className="w-100 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
              >
                Car Category
                <span className="float-end">
                  <i className="fa-solid fa-chevron-down" />
                </span>
              </Link>
            </h6>
          </div>
          <div
            id="collapseTwo"
            className="collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionMain2"
          >
            <div className="card-body-chat">
              <div id="checkBoxes2">
                <div className="selectBox-cont">
                  {props.filterData?.car_category?.map((category: string) => (
                    <label key={category} className="custom_check w-100">
                      <input
                        type="checkbox"
                        name="car_category"
                        checked={
                          props.filters.car_category?.includes(category) ||
                          false
                        }
                        value={category}
                        onChange={props.handleFilterChange}
                      />
                      <span className="checkmark" /> {category}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion" id="accordionMain3">
          <div className="card-header-new" id="headingThree">
            <h6 className="filter-title">
              <Link
                to="#"
                className="w-100 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
              >
                Capacity
                <span className="float-end">
                  <i className="fa-solid fa-chevron-down" />
                </span>
              </Link>
            </h6>
          </div>
          <div
            id="collapseThree"
            className="collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionMain3"
          >
            <div className="card-body-chat">
              <div id="checkBoxes3">
                <div className="selectBox-cont">
                  {props.filterData?.seating_capacities?.map(
                    (capacity: string) => (
                      <label key={capacity} className="custom_check w-100">
                        <input
                          type="checkbox"
                          name="seating_capacity"
                          checked={
                            props.filters?.seating_capacity?.includes(
                              capacity?.toString()
                            ) || false
                          }
                          value={capacity}
                          onChange={props.handleFilterChange}
                        />
                        <span className="checkmark" /> {capacity} Seater
                      </label>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordionMain6">
          <div className="card-header-new" id="headingSix">
            <h6 className="filter-title">
              <Link
                to="#"
                className="w-100 collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                Body Style
                <span className="float-end">
                  <i className="fa-solid fa-chevron-down" />
                </span>
              </Link>
            </h6>
          </div>
          <div
            id="collapseSix"
            className="collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionMain6"
          >
            <div className="card-body-chat">
              <div id="checkBoxes6">
                <div className="selectBox-cont">
                  {props.filterData?.body_style?.map((bodyStyle: string) => (
                    <label key={bodyStyle} className="custom_check w-100">
                      <input
                        type="checkbox"
                        name="body_style"
                        checked={
                          props.filters?.body_style?.includes(bodyStyle) ||
                          false
                        }
                        value={bodyStyle}
                        onChange={props.handleFilterChange}
                      />
                      <span className="checkmark" /> {bodyStyle}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center gap-2 mt-3">
        <button
          type="submit"
          className="d-inline-flex align-items-center justify-content-center btn btn-primary text-nowrap w-100"
        >
          <span>
            <i className="feather icon-filter fs-12 me-2" />
          </span>
          Apply Filter
        </button>

        <button
          onClick={props.handleReset}
          type="button"
          className="d-inline-flex align-items-center justify-content-center w-100 btn btn-order"
        >
          Reset Filter
        </button>
      </div>
    </form>
  );
};

export default MobileFilterSidebar;
